import { render, staticRenderFns } from "./ChargebackPaymentLocalizer.vue?vue&type=template&id=47833078"
import script from "./ChargebackPaymentLocalizer.vue?vue&type=script&lang=js"
export * from "./ChargebackPaymentLocalizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports